/**
 * Edition publishing status
 */
export var PublishingStatus;
(function (PublishingStatus) {
    PublishingStatus["DRAFT"] = "DRAFT";
    PublishingStatus["SCHEDULING"] = "SCHEDULING";
    PublishingStatus["SCHEDULED"] = "SCHEDULED";
    PublishingStatus["PUBLISHED"] = "PUBLISHED";
    PublishingStatus["UNSCHEDULING"] = "UNSCHEDULING";
    PublishingStatus["PUBLISHING"] = "PUBLISHING";
})(PublishingStatus || (PublishingStatus = {}));
/**
 * publishing status of the content item
 *
 * NONE - hasn't been published before
 *
 * EARLY - changes have been made since last publish
 *
 * LATEST - no changes have been made since last publish
 */
export var ContentItemPublishingStatus;
(function (ContentItemPublishingStatus) {
    ContentItemPublishingStatus["NONE"] = "NONE";
    ContentItemPublishingStatus["EARLT"] = "EARLY";
    ContentItemPublishingStatus["LATEST"] = "LATEST";
})(ContentItemPublishingStatus || (ContentItemPublishingStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHVibGlzaGluZ1N0YXR1cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvUHVibGlzaGluZ1N0YXR1cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGdCQU9YO0FBUEQsV0FBWSxnQkFBZ0I7SUFDMUIsbUNBQWUsQ0FBQTtJQUNmLDZDQUF5QixDQUFBO0lBQ3pCLDJDQUF1QixDQUFBO0lBQ3ZCLDJDQUF1QixDQUFBO0lBQ3ZCLGlEQUE2QixDQUFBO0lBQzdCLDZDQUF5QixDQUFBO0FBQzNCLENBQUMsRUFQVyxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBTzNCO0FBRUQ7Ozs7Ozs7O0dBUUc7QUFDSCxNQUFNLENBQU4sSUFBWSwyQkFJWDtBQUpELFdBQVksMkJBQTJCO0lBQ3JDLDRDQUFhLENBQUE7SUFDYiw4Q0FBZSxDQUFBO0lBQ2YsZ0RBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUpXLDJCQUEyQixLQUEzQiwyQkFBMkIsUUFJdEMifQ==